import * as React from "react";
const SvgFiBrandsFigma = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M19.075 8.245c1.273-.803 2.116-2.187 2.116-3.755 0-2.476-2.1-4.49-4.678-4.49H8.487C5.908 0 3.81 2.014 3.81 4.49c0 1.568.843 2.952 2.116 3.755-1.273.803-2.116 2.187-2.116 3.755s.843 2.952 2.116 3.755c-1.273.802-2.116 2.186-2.116 3.755 0 2.476 2.11 4.49 4.703 4.49 2.621 0 4.755-2.036 4.755-4.539V15.32a4.76 4.76 0 0 0 3.144 1.17h.101c2.58 0 4.679-2.014 4.679-4.49 0-1.568-.843-2.952-2.116-3.755m-5.81-6.774h3.247c1.735 0 3.146 1.354 3.146 3.019s-1.411 3.02-3.146 3.02h-3.246zM5.343 4.49c0-1.665 1.411-3.019 3.145-3.019h3.247V7.51H8.487c-1.734 0-3.145-1.355-3.145-3.02m0 7.51c0-1.665 1.411-3.019 3.145-3.019h3.247v6.039H8.468c-1.725-.011-3.126-1.362-3.126-3.02m6.392 7.461c0 1.692-1.445 3.068-3.222 3.068-1.747 0-3.17-1.354-3.17-3.019s1.411-3.02 3.145-3.02h3.247zm4.778-4.441h-.1c-1.735 0-3.145-1.355-3.145-3.02s1.41-3.019 3.144-3.019h.101c1.735 0 3.146 1.354 3.146 3.019s-1.411 3.02-3.146 3.02"
    />
  </svg>
);
export default SvgFiBrandsFigma;
